import { Component } from '@angular/core';

@Component({
    selector: 'app-breadcrumb-company-user-profile-edit',
    templateUrl: './breadcrumb.company.user.profile.edit.component.html'
})

export class BreadcrumbCompanyUserProfileEditComponent { }
